<form class="kr-exchange-set-crypto-fiat-amount__form" [formGroup]="form()">
  <div>
    <label translate="exchange.dialog.transferType"></label>
    <div
      class="kr-exchange-set-crypto-fiat-amount__row kr-exchange-set-crypto-fiat-amount__gap-32">
      <div class="kr-exchange-set-crypto-fiat-amount__row">
        <fu-radio-option
          formControlName="transferType"
          controlId="transferType"
          [option]="transferType.sepa"
          data-testid="exchange_crypto_fiat_transfer_type_sepa" />
        <kr-copy-tooltip
          [text]="'exchange.dialog.exchangeToAnIBAN' | translate"
          [copy]="false" />
      </div>

      <fu-radio-option
        formControlName="transferType"
        controlId="transferType"
        [option]="transferType.swift"
        data-testid="exchange_crypto_fiat_transfer_type_swift" />
    </div>
  </div>

  <kr-search-select
    class="fr-width-100"
    data-testid="exchange_crypto_fiat_from_wallet_select"
    [control]="this.form().controls.walletFromId"
    [items]="wallets()"
    [withSearch]="true"
    [multi]="false"
    [placeholder]="'exchange.dialog.notSelected' | translate"
    [label]="'exchange.dialog.fromWallet' | translate"
    [height]="60">
    <ng-template #itemTpl let-wallet>
      <kr-wallet-item
        [attr.data-testid]="'exchange_crypto_fiat_from_wallet_' + wallet.name"
        [wallet]="wallet" />
    </ng-template>
  </kr-search-select>

  <!--  <fu-text-area-->
  <!--    formControlName="comment"-->
  <!--    [maxLength]="260"-->
  <!--    [rows]="4"-->
  <!--    [label]="'exchange.dialog.paymentDescription' | translate" />-->

  <div
    class="kr-exchange-set-crypto-fiat-amount__row kr-exchange-set-crypto-fiat-amount__gap-16">
    <fu-simple-input
      formControlName="amount"
      data-testid="exchange_crypto_fiat_amount"
      [placeholder]="'exchange.dialog.amount' | translate"
      [label]="'exchange.dialog.amount' | translate"
      [isReadonly]="!!form().controls.amountReceive.value"
      [errorDictionary]="{
        min:
          'transfer.form.amount.validator.min'
          | translate: { min: walletTransferMinAmount },
        pattern: 'transfer.form.amount.validator.pattern' | translate,
        invalidBalance: 'errors.insufficient.funds' | translate,
        maxDecimals:
          'transfer.form.amount.validator.maxDecimals'
          | translate: { max: walletTransferMaxDecimals },
      }"
      [iconTemplate]="coinFrom" />

    <fu-simple-input
      formControlName="amountReceive"
      data-testid="exchange_crypto_fiat_amount_to_receive_input"
      [placeholder]="'exchange.dialog.amountToReceive' | translate"
      [label]="'exchange.dialog.amountToReceive' | translate"
      [isReadonly]="!!form().controls.amount.value"
      [errorDictionary]="{
        pattern: 'transfer.form.amount.validator.pattern' | translate,
      }"
      [iconTemplate]="coinTo" />
  </div>

  <!--  <div class="kr-exchange-set-crypto-fiat-amount__hint">-->
  <!--    <fu-icon iconName="information" size="16" />-->
  <!--    {{-->
  <!--      'exchange.dialog.minimumExchangeAmount'-->
  <!--        | translate: { limit: minAmountToExchange }-->
  <!--    }}-->
  <!--  </div>-->
</form>

<ng-template #coinFrom>
  <div
    class="kr-exchange-set-crypto-fiat-amount__coin-icon"
    data-testid="exchange_crypto_fiat_coin_from">
    {{ wallet().coin?.symbol }}
  </div>
</ng-template>

<ng-template #coinTo>
  <div
    class="kr-exchange-set-crypto-fiat-amount__coin-icon"
    data-testid="exchange_crypto_fiat_coin_to">
    EUR
  </div>
</ng-template>
